import axios from 'axios';

import { apiUrl, config } from '../Shared/config';


export const updateWidgets = async (widgets, scenarioId, type) => {

  if (type === "reporting") {
    // console.log("9 - updateReportingColumns=", columns, scenarioId);
    try {
      const { data } = await axios.put(apiUrl + 'widgets/reporting', { widgets, scenarioId }, config);

      return data.success ? data : data?.error;

    } catch (error) { console.log("15 - error=", error); return error.response?.data?.error || 'error'; }
  }
};


export const getWidgets = async (scenarioId, devicesType) => {

  try {
    const { data } = await axios.get(apiUrl + 'widgets/reporting' + (scenarioId !== undefined ? `/scenario=${scenarioId}` : ``) + (devicesType !== undefined ? `&devicesType=${devicesType}` : ``), config);

    return data.success ? data : data?.error;

  } catch (error) { return error.response?.data?.error || 'error'; }

};

